import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Toolbar from 'components/Layout/Toolbar';
import { allowedGraphStatuses, IVentureHistoryMetrics, IVentureStatusMetrics } from 'interfaces/dashboard';
import React, { ChangeEvent, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import RxOp from 'rxjs-operators';
import dashboardService from 'services/dashboard';
import selectedVentureService from 'services/profile';

import CardGraphs from '../Component/Card';
import VentureSelection from '../Component/VentureSelection';
import HistoricVentureStatus from '../Graphs/HistoricVentureStatus';
import VentureStatus from '../Graphs/StatusesBar';

// import StatusesGeneral from '../Graphs/StatusesLegend';

const ViewEntity = () => {
  const history = useHistory();
  const [ventureFilter, setVentureFilter] = useState<number[]>([]);

  const handleDashboardVenture = (ventureId: number, name: string) => () => {
    selectedVentureService
      .setProfile({ id: Number(ventureId), name })
      .pipe(RxOp.logError())
      .subscribe((res) => {
        history.push(`/documentation/dashboard/venture/${ventureId}`);
      });
  };

  /*   const [totalsByStatus] = useObservable<IStatusMetrics[]>(() => {
      return dashboardService.getTotalsByStatus().pipe(
        RxOp.logError(),
      );
    }, []); */

  const [venturesStatus] = useObservable<IVentureStatusMetrics[]>(() => {
    return dashboardService.getVenturesStatuses().pipe(
      RxOp.logError(),
      RxOp.map((data) =>
        ventureFilter
          ? data.filter((i) => ventureFilter.includes(i.ventureId))
          : data
      )
    );
  }, [ventureFilter]);

  const [historyVentureStatus] = useObservable<IVentureHistoryMetrics>(() => {
    return dashboardService.getVenturesHistory().pipe(
      RxOp.logError(),
      RxOp.map((data) => {
        const ventures = ventureFilter
          ? data.ventures.filter((i) => ventureFilter.includes(i.id))
          : data.ventures;
        return { ...data, ventures };
      })
    );
  }, [ventureFilter]);

  const handleFilterVenure = (event: ChangeEvent<{ value: number[] }>) => {
    const { value } = event.target;
    setVentureFilter(value);
  };

  return (
    <>
      <Toolbar
        title='Dashboard'
        breadcrumbs={[
          { title: 'Dashboard', href: '/documentation/dashboard' },
        ]}
        hideVentureSelect
      />
      <Container>
        <Card>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container justify="space-between">
                  <Grid item>
                    <Typography variant="h6" color="primary" style={{ fontWeight: 700 }}>
                      Empreendimentos
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={5} md={4} lg={3}>
                    <VentureSelection onChange={handleFilterVenure} value={ventureFilter}/>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {venturesStatus && (
                  <CardGraphs bgcolor="rgba(226,221,235,0.5)">
                    <Grid container spacing={2}>
                      {venturesStatus.sort((a, b) => a.ventureId - b.ventureId).map((ds, index) => (
                        <Grid
                          item
                          key={`document-status-graph-${ds.ventureId}-${index}`}
                          xs={12}
                          sm={6}
                          lg={4}
                          xl={3}
                        >
                          <VentureStatus
                            metrics={ds.statusByVenture.filter((sv) =>
                              allowedGraphStatuses.includes(sv.status)
                            )}
                            label={ds.ventureName}
                            onClick={handleDashboardVenture(ds.ventureId, ds.ventureName)}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </CardGraphs>
                )}
              </Grid>
              {historyVentureStatus && (
                <Grid item xs={12}>
                  <HistoricVentureStatus metrics={historyVentureStatus} />
                </Grid>
              )}
              {/* {totalsByStatus && (
                <Grid item xs={12} sm={12} md={12} lg={4}>
                  <StatusesGeneral metrics={totalsByStatus} />
                </Grid>
              )} */}
            </Grid>
          </CardContent>
        </Card>
      </Container>
   </>
  );
};
export default ViewEntity;
